import React from 'react';
import { PlusIcon } from '@components/Icons';
import DropdownMenu from '@components/Menus/DropdownMenu';
import styles from './MultipleAccountsBtn.module.scss';
import { DropdownMenuOption } from '@app/types';

export default function MultipleAccountsBtn({ options }: { options: DropdownMenuOption[] }) {
  return (
    <DropdownMenu
      menuClassName={styles.moreAccountsMenu}
      expandFrom="bottom-left"
      options={options}
      triggerClassName={styles.moreAccountsBtn}
      disabled={options.length === 0}
      triggerProps={{
        children: (
          <>
            <PlusIcon className={styles.btnIcon} width={12} height={12} />
            Add Multiple Accounts
          </>
        ),
      }}
      side="top"
    />
  );
}
